import { useCallback, useRef, useState } from "react";

/** The composer's own text and focus. Nothing else lives here. */
export const useComposer = () => {
  const [text, setText] = useState("");
  const field = useRef<HTMLTextAreaElement>(null);
  const fill = useCallback((value: string) => {
    setText(value);
    field.current?.focus();
  }, []);
  // One character onto the end, for a key pressed somewhere in the pane that
  // takes no text. Reads the current value through the setter rather than
  // closing over it, so the identity is stable and the pane can subscribe once.
  const append = useCallback((character: string) => {
    setText((current) => `${current}${character}`);
    field.current?.focus();
  }, []);
  // Focus without writing anything, for "answer in your own words": filling
  // with an empty string would throw away a draft the reader had started.
  const focus = useCallback(() => field.current?.focus(), []);
  return { text, setText, field, fill, focus, append };
};

export type Composer = ReturnType<typeof useComposer>;
